

import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../../components/CustomButton";
import CustomText, { textStyles } from "../../../../components/CustomText";
import deletemodel from "../../../../assets/deletemodel.svg";

const DeleteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  department,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 3,
          paddingTop: "20px",
            paddingBottom: "20px",
              paddingLeft: "5px",
                paddingRight: "5px",
        },
      }}
    >
      {/* Logo */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <img src={deletemodel} alt="delete" width={50} height={50} />
      </Box>

      {/* Title */}
      <CustomText
        sx={{
          ...textStyles.h1,
          fontSize: "20px",
          fontWeight: 600,
          textAlign: "center",
          mb: 0,
          color: "#2C384C",
        }}
      >
        {t("deleteModal.title")}
      </CustomText>

      {/* Message */}
      <DialogContent sx={{ textAlign: "center", px: 2, pb: 1 }}>
               <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 500, color: "#2C384C", textAlign: "center", lineHeight:"32px"}}>
     
          {t("deleteModal.message", { name: department?.name || "---" })}
        </CustomText>
      </DialogContent>

      {/* Actions */}
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems:'center',
          gap: 2,
          pb: 2,
        }}
      >
    
           <Button
                      variant="outlined"
                           onClick={onClose}
                      sx={{
                        fontSize: 15,
                        textTransform: "none",
                        borderRadius: "5px",
                        fontFamily: "Poppins, sans-serif",
                        color: "#006EC2",
                        border: "2px solid #006EC2",
                        px: 3,
                        py: 0.8,
                        // height: "fit-content",
                      }}
                    >
                    {t("deleteModal.cancel")}
                    </Button>

            <CustomButton
        onClick={onConfirm}
          disabled={loading}
          size="medium"
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {loading && (
                <CircularProgress
                  size={18}
                  thickness={4}
                  sx={{ color: "#ffffff" }}
                />
              )}
      {t("deleteModal.delete")}
            </Box>
          }
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmModal;
